import $ from 'jquery'
import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom";
import templateData, { localsMessages, isMobileHeaderExp } from '../../utility/getTemplateData'
import { hideLanguageSelector } from '../../utility/languageSelector';
import { StyleSheet, css } from 'aphrodite';

const STYLES = StyleSheet.create({
	errorText:{
		fontWeight: 400,
		fontSize: '0.8125rem',
		fontFamily: 'pp-sans-big-regular',
		color: '#6c7378'
	}
});
class ThreeDSError extends React.Component {
	
	componentDidMount = () => {
		$('.spinneroverlay').hide()
		hideLanguageSelector();
	}

	handleTryAgain = () => {
        this.props.history.push(`/donate?token=${templateData.token}`)
	}

	render() {

        const error = localsMessages('errors/threeDSError');
        
		return (
			<div className={`donate_wrapper ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
				<div className="container">
					<div className="col-xs-12 col-sm-12 col-md-12 text-center">
						<div className="error_page_landing">
							<h1 className="text-center"><span className="icon icon-large icon-attention-large" aria-hidden="true"></span></h1>
							<p className="error_message1">{error.errorMessage}</p>
							<div className={`error_message2 ${css(STYLES.errorText)}`} >
								<p>{error.tryAgain}</p>
							</div>
							<div style={{ maxWidth: 360, margin: '50px auto 0px' }}>
								<button type="button"
									className="vx_btn vx_btn-block"
									onClick={this.handleTryAgain} >
									{error.tryCard}
								</button>
							</div>
	                    </div>
	                </div>
	            </div>
	        </div>
        )
    }
}

export default withRouter(ThreeDSError);



// WEBPACK FOOTER //
// ./pages/error/threeDSError.js